import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";
import GdprDialog from "./GDPRDialog";

interface IFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function GdprFilters({ callTableViewModel, setCallTableViewModel }: IFiltersProps) {
    const [open, setOpen] = useState(false);


    const text =
        <Typography variant="body1">
            {
                "PII / GDPR"
            }
            {
                (callTableViewModel.filters.gdprFilters.question != '') &&
                ' - ' + callTableViewModel.filters.gdprFilters.question + ' - ' + callTableViewModel.filters.gdprFilters.answer
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <GdprDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}